angular.module('rings-app.directives.user', ['usersService'])
/*
* Directive to display form to change the user
*/
.directive('userDetailForm', ['usersService','codebookService','$rootScope','$filter',function(usersService,codebookService,$rootScope,$filter){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-detail-form.tpl.html',
    scope : { },                                            // isolated scope
    controllerAs : 'UsrDetailFormCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.userInfo = angular.copy($rootScope.user);
      self.userInfo.rings.Birthday = new Date(self.userInfo.rings.Birthday); // for some reason this is necessary
      //self.userInfo.rings.Birthday.setDate(self.userInfo.rings.Birthday.getDate() + 1);      
      self.showDetailForm = false;
      self.showPwdForm = true;
      self.showLocForm = false;
      self.okresy = [];
      self.showAlert = false;
      self.datePickerOpened = false;
      self.scheme = $rootScope.user.rings.scheme;

      codebookService.fetchOkresy(self.scheme.substring(0, 2))
        .then(function(data){
          self.okresy = data;
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      // update user
      this.updateUser = function(){    
        var body = usersService.constructJSONFromUserInfo(self.userInfo);
        usersService.updateUser(body).then(
          function(data) {
            if (typeof data.error !== 'undefined') {       // error
              alert($filter('translate')("SAVE.ERROR"));
            } else {   
              // if ringer changes information, change also project specific data
              if (self.userInfo.rings.title == 'user'){
                usersService.updateRingsUser(body).then(
                  function(data) {
                    if (typeof data.error !== 'undefined') {       // error
                      alert($filter('translate')("SAVE.ERROR"));
                    } else {                                     //  OK
                      // update rootUser
                      $rootScope.user = self.userInfo;
                      // update Local Storage
                      localStorage.setItem('userInfo', $rootScope.user);
                      self.showAlert = true;
                      //alert($filter('translate')("SAVE.OK"));
                    } 
                  });
              // if other role than ringer changes information, continue without changing project specific data
              } else {
                $rootScope.user = self.userInfo;
                self.showAlert = true;
                // update Local Storage
                localStorage.setItem('userInfo', $rootScope.user);
                //alert($filter('translate')("SAVE.OK"));
              }
              
            } 
          });
      }
    }
  }
}])
/*
* Directive to display form to change the user settings
*/
.directive('userSettings', ['usersService','codebookService','$rootScope','$filter'
  ,function(usersService,codebookService,$rootScope,$filter){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-settings.tpl.html',
    scope : { },                                            // isolated scope
    controllerAs : 'UsrSettingsCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.userInfo = angular.copy($rootScope.user);
      self.additionalUrl="?where=UID is "+$rootScope.user.UID;
      
      self.settings = new Setting($rootScope.user.UID);
      
      usersService.fetchUsersettings(self.additionalUrl)
        .then(function(data){
          if (data.length>0){
            self.settings = data[0];
            self.settings.SecretUntil = new Date(self.settings.SecretUntil);
            //self.settings.SecretUntil.setDate(self.settings.SecretUntil.getDate() + 1);
          }          
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      codebookService.fetchCodebook()
        .then(function(data){
          self.codebook = data
        }, function(data){
          alert("Při načítání dat došlo k chybě");
        });

      self.updateSettings = function(){
        var dataToSend = angular.copy(self.settings);
        dataToSend.SimplifiedRingTypes = dataToSend.SimplifiedRingTypes ? 1 : 0;
        if (dataToSend.SecretUntil){
          dataToSend.SecretUntil = yyyymmdd(dataToSend.SecretUntil);
        } else {
          dataToSend.SecretUntil = null;
        }
        usersService.updateUsersettings(dataToSend)
          .then(function(data){
            if (typeof (data.ok) !== 'undefined' || typeof (data.id) !== 'undefined'){
              self.showAlert = true;
            }
          }, function(data){
            alert("Při načítání dat došlo k chybě");
        });

      }

    }
  }
}])
/*
* Directive to display form to change the user settings
*/
.directive('userAccount', ['usersService','$rootScope'
  ,function(usersService,$rootScope,$filter){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-account.tpl.html',
    scope : { },                                            // isolated scope
    controllerAs : 'UsrAccountCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.userInfo = angular.copy($rootScope.user);
      self.additionalUrl="?where=UID is "+$rootScope.user.UID;
      self.accountMovements = [];
      
      var additionalUrl = '?where=UID is '+ self.userInfo.UID;       
       // OK - reload list of account movements from server
      usersService.fetchAccountMovements(additionalUrl).then(
        function(data){
          self.accountMovements = data;
          self.currentAccountMovement = new AccountMovement();
          self.doingResolve = false;
      });

      self.sum = function(arr,val){
        return arr.reduce( function(a, b){
          return a + b[val];
        }, 0);
      }

    }
  }
}])
/*
* Directive to display user detail
*/
.directive('userDetail', ['$rootScope','$filter','usersService','myConfig',function($rootScope, $filter,usersService,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-detail.tpl.html',
    scope : { },                                            // isolated scope
    controllerAs : 'UsrDetailCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.showDetailForm = true;
      self.showPwdForm = true;
      self.showLocForm = true;
      self.year = myConfig.currentYear;
      self.showAlert = false;
      self.completed = $rootScope.user.rings.Complete;
      // for switching the ringing scheme
      self.scheme = $rootScope.user.rings.scheme;
      self.defaultScheme = $rootScope.user.rings.scheme;
      self.otherScheme = $rootScope.user.rings.otherScheme;
      // functions
      self.CompleteData = function(){
        if (confirm('Opravdu jste zapsal/-a všechna data za rok ' + self.year + '?')){
          var dataToSend = {
            UID: $rootScope.user.UID,
            Complete: self.year
          };
          usersService.updateRingsUser(dataToSend).then(
            function(data) {
              if (typeof data.error !== 'undefined') {       // error
                alert($filter('translate')("SAVE.ERROR"));
              } else {     
                self.showAlert = true;                                //  OK
                // update rootUser
                $rootScope.user.rings.Complete = self.year;
                // update Local Storage
                localStorage.setItem('userInfo', $rootScope.user);
              } 
            });

        }
      }

      this.changeScheme = function(scheme) {
        var copiedScheme = angular.copy($rootScope.user.rings.scheme);
        $rootScope.user.rings.scheme = angular.copy($rootScope.user.rings.otherScheme);
        $rootScope.user.rings.otherScheme = copiedScheme;
        self.scheme = scheme;
        let dataToSend = {
          UID: $rootScope.user.UID,
          ID_RingingScheme: $rootScope.user.rings.scheme,
          ID_OtherRingingScheme: $rootScope.user.rings.otherScheme
        };
        usersService.updateRingsUser(dataToSend).then(
          function(data) {
            if (typeof data.error !== 'undefined') { 
              alert($filter('translate')("SAVE.ERROR"));
            } else {                                     //  OK
              // update Local Storage
              localStorage.setItem('userInfo', $rootScope.user);
            } 
        });
      }

    }
  }
}])
/*
* directive to display page with users rings
*/
.directive('userRings', ['ringsService','$rootScope',function(ringsService,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-rings.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'UserRingsCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.year = 2023;
      self.orderMade = false;
      self.showAccountInfo = false;
      self.userInfo = angular.copy($rootScope.user);
      self.complete = self.userInfo.rings.Complete;
      self.licenceNumber = $rootScope.user.rings.LicenceNumber;
      self.scheme = $rootScope.user.rings.scheme;

      /*disable orders*/
      if ((self.complete + 1) < (new Date()).getFullYear()) {
        self.disableOrders = true;
      } else {
        self.disableOrders = false;
      }
    }
  }
}])
/*
* Directive to display table of rings belonging to user
*/
.directive('userRingsTable', ['ringsService','$rootScope',function(ringsService,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-rings-table.tpl.html',
    scope : {
      orderMade : '=',
    },                                            // isolated scope
    controllerAs : 'UsrRingsTableCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.search = {
        ID_RingType: ''
      };

      var userId = $rootScope.user.UID;
      self.additionalUrl = 'user=' + userId + '&scheme=' + $rootScope.user.rings.scheme;

      ringsService.fetchRingsSeries(self.additionalUrl)
        .then(function(data){
          self.rings = data;
        }, function(err){
          alert("Při načítání dat došlo k chybě");
      });

    },
    link: function (scope, element, attrs, ctrl) {
      scope.$parent.$watch(attrs.orderMade, function() {
        ringsService.fetchRingsSeries(ctrl.additionalUrl)
          .then(function(data){
            ctrl.rings = data;
          }, function(data){
            alert("Při načítání dat došlo k chybě");
          });
        });
    }

  }
}])
/*
* Directive to display table of rings belonging to user
*/
.directive('userUsedRingsTable', ['ringsService','$rootScope',function(ringsService,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-used-rings-table.tpl.html', 
    scope : {
      year : '=',
    }, 
    controllerAs : 'UsrUsedRingsTableCtrl',
    bindToController: true,
    controller : function (){

      // variables
      var self = this;
      self.rings = [];
      var userId = $rootScope.user.UID;
      self.additionalUrl = 'user=' + userId + '&year=' + self.year;

      ringsService.fetchUsedRingsSeries(self.additionalUrl)
        .then(function(data){
          self.rings = data;
        }, function(err){
          alert("Při načítání dat došlo k chybě");
      });

    }

  }
}])
/*
* Directive to display form to make ring order
*/
.directive('makeRingOrderForm', ['ringsService','$rootScope','myConfig',function(ringsService,$rootScope,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/ringorder-form.tpl.html',
    scope : { 
      orderMade : '=',
      selectUser : '=',
      forcedOpen : '='
    },                                            // isolated scope
    controllerAs : 'RingOrderFormCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.ringtypes = null;
      self.newOrder = new RingOrder();
      self.newOrder.RingType = null;                // need to set to null, otherwise validation fails
      self.ringOrderItems = [];
      self.ordersOpen = myConfig.ordersOpen;
      self.currencySymbol = myConfig[$rootScope.user.rings.scheme].currencySymbol;
      self.userOrdered = null;
      self.scheme = $rootScope.user.rings.scheme;

      if (!self.selectUser){
        self.userOrdered = $rootScope.user.UID;
      }

      this.loadRingTypes = function() {
         // load ringtypes
        ringsService.fetchRingTypes(false, self.scheme)
          .then(function(data){
            self.ringtypes = data;
          }, function(data){
            alert(data);
          });
      }

      this.loadRingTypes();

      // add type and amount to list of ring order item and reset form to pristine state
      this.addRingOrderItem = function(){
        // validate if some ring types are multiple times in the order
        if(this.ringOrderItems.length > 0){         
          // list of ringtypes
          var ringTypes = this.ringOrderItems.map(function(item){ return item.RingType });
          // is already present?
          var alreadyPresent = ringTypes.indexOf(this.newOrder.RingType) != -1;
          if (alreadyPresent){
            alert('Zadaný typ kroužku je již v objednávce obsažen');
            $scope.insertRingsForm.$setPristine();      // reset to pristine state
            return;
          }
        } 

        this.ringOrderItems.push(this.newOrder);
        self.newOrder = new RingOrder();
        self.newOrder.RingType = null;              // need to set to null, otherwise validation fails
        $scope.insertRingsForm.$setPristine();      // reset to pristine state
      }

      this.deleteRingOrderItem = function(item){
        // find position in array by ring type
        var ringTypes = this.ringOrderItems.map(function(item){ return item.RingType });
        var index = ringTypes.indexOf(item.RingType);
        this.ringOrderItems.splice(index, 1)
      }

      // when autocompleter option for municipality is selected, update model
      this.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.userOrdered = null;
          return;
        }
        self.userOrdered = selectedValue.originalObject.UID;
      };

      // create ring order
      this.makeRingOrder = function() {

        var dataToSend = {"ringOrderItems": self.ringOrderItems, 
                          "ID_UserOrdered": self.userOrdered,
                          "ID_RingingScheme": self.scheme};
        var result = ringsService.makeRingOrder(dataToSend).then(
            function(result) {
              if (result.id) {
                self.newOrder = new RingOrder();
                self.ringOrderItems = [];
                alert("Data byla úspěšně uložena");
                self.orderMade = !self.orderMade;
              } else {
                alert("Při ukládání nastala chyba. Překontrolujte zadávané údaje, případně se obraťte na administrátora aplikace");
              }
            }
          );
      }

      // sum of rings in order
      this.getTotalPrice = function(){
        var sum = 0;
        for (var i = 0; i < self.ringOrderItems.length; i++){
          sum += self.ringOrderItems[i].RingType.Price * self.ringOrderItems[i].Amount - self.ringOrderItems[i].Discount;
        }
        return sum;
      }

    }
  }
}])
/*
* Directive to display form to make ring order
*/
.directive('lostRingForm', ['ringsService','$rootScope','myConfig',function(ringsService,$rootScope,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-lost-ring.tpl.html',
    scope : { 
      orderMade : '='
    },                                            // isolated scope
    controllerAs : 'LostRingCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.ringType = null;
      self.from = null;
      self.to = null;
      self.showAlert = false;
      self.showAlertNoData = false;
      self.lostRings = [];

      // load ringtypes
      ringsService.fetchRingTypes(true, $rootScope.user.rings.scheme)
        .then(function(data){
          self.ringtypes = data;
        }, function(data){
          alert(data);
        });

      // validate
      self.validate = function(){
        if (self.to < self.from){
          self.errorText = 'Hodnota od nemůže být vyšší než hodnota do';
          return true;
        } else {
          self.errorText = null;
          return false;
        }
      }

      // send to server
      self.process = function(){
        // prepare data to send to server
        var dataToSend = {
          ringType: self.ringType,
          valFrom: self.from,
          valTo: self.to
        };
        // send data
        ringsService.lostRing(dataToSend)
          .then(function(result){
            switch (result.returnValue) {
              case "OK":
                self.orderMade = !self.orderMade;
                self.showAlert = true;
                self.ringType = null;
                self.from = null;
                self.to = null;
                break;
              case "ERROR_RING_USED":
                alert("Kroužek již byl použit, nelze jej označit jako ztracený");
                break;
              case "ERROR_RING_NOT_IN_DB":
                alert("Zadané kroužky nejsou na skladu nebo jsou přiřazeny jinému kroužkovateli");
                break;
              default:
                alert("Neznámá chyba, obraťte se na administrátora aplikace");
                break;
            }
          });
      }

      // show list of own lost rings
      self.showLostRings = function(){
        var userId = $rootScope.user.UID;
        var additionalUrl = 'where=ID_User is '+userId+' and ID_RingStatus is 5';
        ringsService.fetchRings(additionalUrl)
          .then(function(data){
            self.lostRings = data;
            if (self.lostRings.length == 0){
              self.showAlertNoData = true;
            }
          });
      }

      // return to my stock
      self.returnToStock = function(ring){
        var dataToSend = {
          ID: ring.ID,
          ID_RingStatus: 3
        }
        ringsService.editRing(dataToSend)
          .then(function(data){
            if (data.ok){
              self.showAlert = true;
            } else {
              alert("Došlo k chybě");
            }
          });

      }

    }
  }
}])
/*
* Directive to display list of orders for user
*/
.directive('listRingorders', ['ringsService','$rootScope',function(ringsService,$rootScope){
  return {
    restrict: 'AE',
    templateUrl : 'pages/list-ringorders.tpl.html',
    scope : { 
      orderMade : '='
    },                                        // isolated scope
    controllerAs : 'RingOrderListCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.ringorders = [];
      self.otherScheme =  $rootScope.user.rings.otherScheme;
      // load data
      var userId = $rootScope.user.UID;

      // functions
      this.totalPrice = function(ringorder){
        var total = 0;
        if (ringorder.ID_Status == 1){
          for (var i = 0; i < ringorder.ringOrderItems.length; i++){
            total += ringorder.ringOrderItems[i].PriceOrdered * ringorder.ringOrderItems[i].Amount - ringorder.ringOrderItems[i].Discount;
          }
        } else {
          for (var i = 0; i < ringorder.ringOrderItems.length; i++){
            total += ringorder.ringOrderItems[i].PriceAssigned * (ringorder.ringOrderItems[i].ToValue - ringorder.ringOrderItems[i].FromValue + 1) - ringorder.ringOrderItems[i].Discount;
          }
        }
        return total;
      }

      this.updateRingOrderPrice = function(){
        for (var i=1;i<self.ringorders.length;i++){
          var price = self.totalPrice(self.ringorders[i]);
          self.ringorders[i].Price = self.totalPrice(self.ringorders[i]);
        }
      }

      // only my orders,which are not closed
      //self.additionalUrl = 'where=ID_UserOrdered is ' + userId + ' and ID_Status isnot 5';
      self.additionalUrl = 'where=ID_UserOrdered is ' + userId + ' and ID_Status<5 and ID_Status != 3&withItems=true';
      ringsService.fetchRingOrders(self.additionalUrl)
        .then(function(data){
          self.ringorders = data;
          //self.updateRingOrderPrice();
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      // get list of ring orders for current user
      this.getRingOrders = function(){
        ringsService.fetchRingOrders(self.additionalUrl)
          .then(function(data){
            self.ringorders = data;
            //self.updateRingOrderPrice();
          }, function(data){
            alert(data);
          });
      }

      // delete ring order item
      this.deleteRingOrderItem = function(id){
        if (confirm('Opravdu chcete smazat položku objednávky?')) {
          ringsService.deleteRingOrderItem(id)
            .then(function(data){
              self.getRingOrders();
              if (typeof(data.error) !== 'undefined'){      
                alert('Při mazání položky došlo k chybě');
              }             
            }, function(data){
              alert('Při mazání položky došlo k chybě');
            });
          }
      }  

      // delete ring order item
      this.editRingOrderItem = function(ringOrderItem){
        if (confirm('Opravdu chcete změnit položku objednávky?')) {
          var dataToSend = {
            "ID": ringOrderItem.ID,
            "Amount": ringOrderItem.Amount
          }
          ringsService.editRingOrderItem(dataToSend)
            .then(function(data){
              self.getRingOrders();
              if (typeof(data.error) !== 'undefined'){      
                alert('Při ukládání položky došlo k chybě');
              }             
            }, function(data){
              alert('Při ukládání položky došlo k chybě');
            });
          }
      }  

      // confirm ring order
      this.confirmRings = function(ringOrder) {
        var userId = $rootScope.user.UID;
        var dataToSend = {"ID_UserOrdered": userId,
                          "ringOrderItems": ringOrder.ringOrderItems,
                          "ID": ringOrder.ID,
                          "ID_Status": ringOrder.ID_Status,
                          "action":"confirm_assign"};
        ringsService.editRingOrder(dataToSend).then(
            function(result) {
              switch (result.returnValue) {
                  case "OK":
                    self.orderMade = !self.orderMade;
                    //self.getRingOrders();
                    //ringsService.updateNRingOrders();
                    // TODO - reload list of user's rings
                    alert("Data byla úspěšně uložena");
                    break;
                  case "ERROR_TO_LOWER_THAN_FROM":
                    alert("Hodnota OD musí být menší než hodnota DO");
                    break;
                  case "ERROR_OUT_OF_RANGE":
                    alert("Hodnoty OD a DO jsou mimo přípustný interval");
                    break;
                  case "ERROR_RING_NOT_IN_DB":
                    alert("Zadané kroužky nejsou na skladu");
                    break;
                  default:
                    alert("Neznámá chyba, obraťte se na administrátora aplikace");
                    break;
                }
            }
          );
      }

      // cancel ring order
      this.cancelRings = function(ringOrder) {
        var userId = $rootScope.user.UID;
        var dataToSend = {"ID_UserOrdered": userId,
                          "ringOrderItems": ringOrder.ringOrderItems,
                          "ID": ringOrder.ID,
                          "ID_Status": ringOrder.ID_Status,
                          "action":"cancel"};
        var result = ringsService.editRingOrder(dataToSend).then(
            function(result) {
              switch (result.returnValue) {
                  case "OK":
                    self.orderMade = !self.orderMade;
                    //self.getRingOrders();
                    //ringsService.updateNRingOrders();
                    // TODO - reload list of user's rings
                    alert("Data byla úspěšně uložena");
                    break;
                  case "ERROR_TO_LOWER_THAN_FROM":
                    alert("Hodnota OD musí být menší než hodnota DO");
                    break;
                  case "ERROR_OUT_OF_RANGE":
                    alert("Hodnoty OD a DO jsou mimo přípustný interval");
                    break;
                  case "ERROR_RING_NOT_IN_DB":
                    alert("Zadané kroužky nejsou na skladu");
                    break;
                  default:
                    alert("Neznámá chyba, obraťte se na administrátora aplikace");
                    break;
                }
            }
          );
      }
    },
    link: function (scope, element, attrs, ctrl) {
            scope.$parent.$watch(attrs.orderMade, function() {
              ringsService.fetchRingOrders(ctrl.additionalUrl)
                .then(function(data){
                  ctrl.ringorders = data;
                }, function(data){
                  alert("Při načítání dat došlo k chybě");
              });
            });
        }
  }
}])
/*
* directive to display page with users locations and form
*/
.directive('userLocations', ['locationService','$rootScope','$cookieStore','$state','$timeout','myConfig'
            ,function(locationService,$rootScope,$cookieStore,$state,$timeout,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-locations.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'UserLocationCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.locality = new Locality();
      self.additionalUrl = "where=UID is " + $rootScope.user.UID;
      self.showAlert = false;
      self.savingData = false;
      self.mapOption = myConfig[$rootScope.user.rings.scheme].mapOption;
      self.obceUrl = myConfig[$rootScope.user.rings.scheme].obceUrl;

      // load data
      /*locationService.fetchUserLocations(self.additionalUrl)
        .then(function(data){
          self.userlocations = data;
        }, function(data){
          alert(data);
        });*/

      // functions
      this.getUserLocations = function(){
        locationService.fetchUserLocations(self.additionalUrl)
          .then(function(data){
            self.userlocations = data;
          }, function(data){
            alert(data);
          });
      }

      this.getUserLocations();

      this.updateLocation = function(location){
        // create new location from UserLocation
        self.locality = location;
        self.locality.coords = {longitude: location.longitude, latitude: location.latitude};
        self.local
        // update municipality in autocompleter
        $scope.$broadcast('angucomplete-alt:changeInput', 'select-municipality', location.Municipality);
        self.locality.crdsText = parseFloat(self.locality.coords.latitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.longitude).toFixed(5);

        // update map
        self.mapOption = {
          lat: location.latitude,
          lng: location.longitude,
          zoom: 14
        };
        $timeout(function() {
          $rootScope.$broadcast('locationUpdated');
        }, 100);
      }

      this.insertObservation = function(location){
        var params = {'idloc':location.ID};
        $state.go('app.user.observation',params);
      }

      // when autocompleter option is selected, update zoom and center of the map
      this.updateMunicipality = function (selectedValue) {
        if (selectedValue) {
          var str = selectedValue.originalObject.obec;
          self.locality.Municipality =str.substring(0,str.indexOf('['));
          self.locality.KODCOBE = selectedValue.originalObject.KODCOBE;
          self.locality.ID_MunicipalityPart = selectedValue.originalObject.ID;
          self.mapOption.lat = selectedValue.originalObject.latitude;
          self.mapOption.lng = selectedValue.originalObject.longitude;
          self.mapOption.zoom = 14;       
        }
      };

      // parses text and retrieves coordinates from in
      this.updateCrds = function(){
        if (self.locality.crdsText == null || self.locality.crdsText == ''){
          self.locality.err = false;
          return;
        }
        // example 48.255757N, 17.597398E
        var regexPattern1 = /^([0-9]{2}\.[0-9]*)N?, ([0-9]{2}\.[0-9]*)E?$/i;
        // example 50°4'49.008"N, 14°24'37.656"E
        var regexPattern2 = /^([0-9]{2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"N, ([0-9]{2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"E?$/i;
        // example N 50°2.96520', E 14°30.58850'
        var regexPattern3 = /^N ([0-9]{2})°([0-9]{1,2}\.[0-9]+)', E ([0-9]{2})°([0-9]{1,2}\.[0-9]+)$'/i
        if (regexPattern1.test(self.locality.crdsText)){
          var match = regexPattern1.exec(self.locality.crdsText);
          self.locality.coords.longitude = match[2];
          self.locality.coords.latitude = match[1];
          self.locality.err = false;
        } else if (regexPattern2.test(self.locality.crdsText)){
          var match = regexPattern2.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[4];
          minuteN = match[2];
          minuteE = match[5];
          secondN = match[3];
          secondE = match[6];
          var lon = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
          var lat = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else if (regexPattern3.test(self.locality.crdsText)){
          var match = regexPattern3.exec(self.locality.crdsText);
          degreeN = match[1];
          degreeE = match[3];
          minuteN = match[2];
          minuteE = match[4];
          var lon = parseFloat(degreeN) + parseFloat(minuteN)/60;
          var lat = parseFloat(degreeE) + parseFloat(minuteE)/60;
          self.locality.coords.longitude =lon;
          self.locality.coords.latitude = lat;
          self.locality.err = false;
        } else {
          //self.crdsError = true;
          self.locality.err = true;
        }
      }

      $scope.$watch('locality.crdsText', function() {
        self.updateCrds();
      });

      // delete location
      this.removeLocation = function(loc){
        if (confirm('Opravdu chcete smazat lokalitu '+loc.Name+'?')){
          self.savingData = true;
          locationService.deleteUserLocation(loc.ID)
            .then(function(result){
              if (typeof result.error === 'undefined'){
                self.getUserLocations();
                self.location = new Locality();
                self.showAlert = true;
              } else {
                self.getUserLocations();
                self.location = new Locality();
                alert("Neznámá chyba, obraťte se na administrátora aplikace");
              }              
              self.savingData = false;
              
            });  
          }              
      }


      // insert/update location
      this.saveLocation = function(){
        var newLocation = new Locality();
        newLocation.ID = self.locality.ID;
        newLocation.Name = self.locality.Name;
        newLocation.Municipality = self.locality.Municipality;
        newLocation.Note = self.locality.Note;
        newLocation.coords = self.locality.coords;
        newLocation.KODCOBE = self.locality.KODCOBE;
        newLocation.ID_MunicipalityPart = self.locality.ID_MunicipalityPart;

        if (!newLocation.validate()){
          alert('Lokalita není validní, zkontrolujte, zda jsou vyplněna všechna povinná pole a zda se lokalita nachází v České republice. Obec musí být vybrána ze seznamu obcí.');
          return;
        }

        // construct JSON object
        var dataToSend = {
          UID : $rootScope.user.UID,
          Name : (!self.locality.Name || self.locality.Name.length == 0) ? null : self.locality.Name,
          Municipality : self.locality.Municipality,
          KODCOBE : self.locality.KODCOBE,
          ID_MunicipalityPart: self.locality.ID_MunicipalityPart,
          Note :  (!self.locality.Note || self.locality.Note.length == 0) ? null : self.locality.Note,
          latitude : parseFloat(self.locality.coords.latitude).toFixed(5),
          longitude : parseFloat(self.locality.coords.longitude).toFixed(5),
        }

        // include ID only in PUT request
        if (self.locality.ID != 0){
          dataToSend.ID = self.locality.ID
        }

        // send data
        self.savingData = true;
        var result = locationService.saveUserLocation(dataToSend).then(
          function(result) {
            if (typeof result.error === 'undefined'){
              self.getUserLocations();
              var newLocation = new Locality();
              newLocation.ID = 0;
              self.locality = newLocation;
              self.showAlert = true;
              $rootScope.$broadcast('angucomplete-alt:clearInput');
              //alert("Data byla úspěšně uložena");
            } else {
              self.getUserLocations();
              self.location = new Locality();
              alert("Neznámá chyba, obraťte se na administrátora aplikace");
            }
            self.savingData = false;
          });

      }

    }
  }
}])
/*
* displays table with the records of certain user
*/
.directive('userRecords', ['observationService','codebookService','ringsService','locationService','usersService','$state','$rootScope','$q','$http','myConfig',
  function(observationService,codebookService,ringsService,locationService,usersService,$state,$rootScope,$q,$http,myConfig){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-records.tpl.html',
    scope : {},                                             // isolated scope
    controllerAs : 'UserRecordsCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      // records
      self.records = null;
      self.numRecords = null;
      self.numRecordsPerPage = 100;
      self.settings = new Setting($rootScope.user.UID);
      self.additionalUrl = 'where=owner is ' + "'" + $rootScope.user.User + "'";
      self.showForm = false;
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.doingResolve = false;
      self.doingSummaryResolve = false;
      self.noHistory = true;
      self.locations = [];
      self.selectedLocation = null;
      self.scheme = $rootScope.user.rings.scheme;
      self.druhUrl = myConfig[self.scheme].druhUrl;
      self.obceUrl = myConfig[self.scheme].obceUrl;
      self.query = {
        dateFrom: null,
        dateTo: null,
        dateFromS: null,
        dateToS: null,
        location: null,
        county: null,
        species: null,
        municipality: null,
        ringInformation: null,
        ringNumber: null,
        scheme: null,
        seasonFrom: null,
        seasonTo: null,
        sex: null,
        age: null,
        ringType: null,
        yearsFrom: null,
        yearsTo: null,
        serie: null,
        serieFrom: null,
        serieTo: null
      }
      self.order = {
        date: {
          asc: false,
          desc: true
        },
        ringNumber: {
          asc: false,
          desc: false
        },
        species: {
          asc: false,
          desc: false
        },
        sex: {
          asc: false,
          desc: false
        },
        age: {
          asc: false,
          desc: false
        },
        station: {
          asc: false,
          desc: false
        },
        locality: {
          asc: false,
          desc: false
        },
        method: {
          asc: false,
          desc: false
        },
        operation: {
          asc: false,
          desc: false
        }
      }
      self.seasonRegex = "^(\\d{2}\\.)\\d{2}$"
      self.ringInformation = [
        {"code": 1,"description": "Kroužek přidán"}
        ,{"code": 4,"description": "Kroužek již přítomný"}
        ,{"code": 6,"description": "Kroužek odstraněn"}];
      // summary
      self.years = new Array();
      self.year = (new Date()).getFullYear();
      for (var i = 2009; i <= (new Date()).getFullYear(); i++){
        self.years.push(i);
      }
      self.summaryStats = {
        species:null,
        total:null,
        pull:null,
        ad:null,
        retrap:null
      }
      // charts
      self.chartspecies = null;
      // line chart
      self.chartlineData = [[],[]];
      self.chartlineLabels = [];
      self.chartSeries = ['počet'];
      self.chartlineSeries = ['kroužkování','retrapy'];
      self.chartlineColors = [{
        fillColor: "rgba(151,187,205,0.2)",
        strokeColor: "rgba(151,187,205,1)",
        pointColor: "rgba(151,187,205,1)",
        pointStrokeColor: "#fff",
        pointHighlightFill: "#fff",
        pointHighlightStroke: "rgba(151,187,205,0.8)"
      }];
      // doughnut sex
      self.chartdoughnutData = [];
      self.chartldoughnutLabels = [];
      // doughnut age
      self.chartdoughnut2Data = [];
      self.chartldoughnut2Labels = [];

      // load locations
      // load data
      var userId = $rootScope.user.UID;
      var query = "UID=" + userId;
      //
      locationService.fetchUserLocations(query)
        .then(function(data){
          self.locations = data;          
        }, function(data){
          alert(data);
        });

      // fetch okresy
      codebookService.fetchOkresy(self.scheme.substring(0,2))
        .then(function(data){
          self.counties = data;
        }, function(data){
          alert(data);
        });

      // user settings
      usersService.fetchUsersettings("?where=UID is "+$rootScope.user.UID)
        .then(function(data){
          if (data.length>0){
            self.settings = data[0];
          }          
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      self.templateUrl = 'templates/image-popover.tpl.html';

      self.htmlTemplate = function(photopath){
        var html = '<div><img src="'+self.filePath(photopath)+'" class="img-responsive"></div>';
        return html;
      }

      // path to file
      self.filePath = function(photopath){
        return '/userdata/images/'+photopath+'.jpg';
      };

       // get history
      self.getHistory = function(){
        self.doingResolve = true;
        self.noHistory = false;
        observationService.fetchObservationOverview(1,self.numRecordsPerPage,self.constructUrl())
          .then(function(data){
            // reset additional URL, because it can be taken from url params
            self.additionalUrl = 'where=owner is ' + "'" + $rootScope.user.User + "'";
            self.records = data.items;
            self.numRecords = data.rowCount;
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
        });
      }

      // created additional url string to be passed to service
      self.constructUrl = function(){
        var url = self.additionalUrl;
        var whereRaw = '';
        // add date, if set
        if ((self.query.dateFrom != null && self.query.dateFrom != '')
          || (self.query.dateTo != null && self.query.dateTo != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFrom != null && self.query.dateFrom != ''){
            var dateFrom = yyyymmdd(self.query.dateFrom);
          }
          if (self.query.dateTo != null && self.query.dateTo != ''){
            var dateTo = yyyymmdd(self.query.dateTo);
          }
          url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
        }
        // location
        if (self.query.location != null && self.query.location != ''){
          url += " and locality is '"  + encodeURIComponent(self.query.location) + "'";
        }
        // county
        if (self.query.county != null && self.query.county != ''){
          url += " and county is '"  + self.query.county + "'";
        }
        // species
        if (self.query.species != null){
          // taxonomic tree
          if (self.query.species.GenusId != 0){
            url += " and taxonid is " + self.query.species.TaxonID;
          } else if (self.query.species.FamilyId != 0){
            url += " and genusid is " + self.query.species.TaxonID;
          } else if (self.query.species.OrderId != 0){
            url += " and familyid is " + self.query.species.TaxonID;
          } else {
            url += " and orderid is " + self.query.species.TaxonID;
          }
        }
        // age
        if (self.query.age != null){
          url += " and ageid is '" + self.query.age + "'";
        }
        // sex
        if (self.query.sex != null){
          url += " and sex is '" + self.query.sex + "'";
        }
        // municipality
        if (self.query.municipality != null){
          url += " and kodcobe is " + self.query.municipality;
        }
        // Mark info - musst be constructed for both ring and additional mark
        var markUrl = ''
        var ringUrl = ''
        // scheme
        if (self.query.scheme != null){
          //url += " and station is '" + self.query.scheme+"'";
          ringUrl += " and station is '" + self.query.scheme+"'";
          markUrl += " and mrkStation is '" + self.query.scheme+"'";
        }        
        // ring operation
        if (self.query.ringInformation != null){
          //url += " and idOperation is " + self.query.ringInformation;
          ringUrl += " and idOperation is " + self.query.ringInformation;
          markUrl += " and mrkIdOperation is " + self.query.ringInformation;
        }
        // ring type
        if (self.query.ringType != null){
          //url += " and markType is '" + self.query.ringType + "'";
          ringUrl += " and markType is '" + self.query.ringType + "'";
          markUrl += " and mrkMarkType is '" + self.query.ringType + "'";
        }
        // ringnumber
        if (self.query.ringNumber != null){
          var rn = self.query.ringNumber.replace(/\s/g,'');
          ringUrl += " and ringnumber is '" + rn + "'";
          markUrl += " and mrkRingnumber is '" + rn + "'";
          /*var fullrn = fullRingNumber(rn);
          if (fullrn == rn || fullrn === null){
            //url += " and ringnumber is '" + rn + "'";
            ringUrl += " and ringnumber is '" + rn + "'";
            markUrl += " and mrkRingnumber is '" + rn + "'";
          } else {
            //url += " and (ringnumber is '" + rn + "' or ringnumber is '" + fullrn + "')";
            ringUrl += " and (ringnumber is '" + rn + "' or ringnumber is '" + fullrn + "')";
            markUrl += " and (mrkRingnumber is '" + rn + "' or mrkRingnumber is '" + fullrn + "')";
          }*/
        }
        // put all together
        if (ringUrl.length > 0){
          ringUrl = ringUrl.replace(' and ','');
          markUrl = markUrl.replace(' and ','');
          url += " and (("+ringUrl+") or ("+markUrl+"))";
        }
        // projects
        if(self.query.ces){
          url += " and ces is 1";
        }
        if(self.query.ras){
          url += " and ras is 1";
        }
        // serie
        if (self.query.serie !== null){
          //if (self.query.ringInformation==1 && self.query.ringType == 'A0' && self.query.scheme === $rootScope.user.rings.scheme){
            url += " and serie is '"+self.query.serie+"'";
          //}          
        }
        if (self.query.serieFrom !== null){
          //if (self.query.ringInformation==1 && self.query.ringType == 'A0' && self.query.scheme === $rootScope.user.rings.scheme){
            url += " and serienumber >= "+self.query.serieFrom;
          //}          
        }
        if (self.query.serieTo !== null){
          //if (self.query.ringInformation==1 && self.query.ringType == 'A0' && self.query.scheme === $rootScope.user.rings.scheme){
            url += " and serienumber <= "+self.query.serieTo  ;
          //}          
        }
        // season
        if (self.query.seasonFrom != null && self.query.seasonTo != null){
          var regexPattern = /^([0-9]{1,2})\.([0-9]{1,2})?$/i;
          var matchFrom = regexPattern.exec(self.query.seasonFrom);
          var mFrom = matchFrom[2];
          var dFrom = matchFrom[1];
          var matchTo = regexPattern.exec(self.query.seasonTo);
          var mTo = matchTo[2];
          var dTo = matchTo[1];
          var strFrom = ("0" + mFrom).slice (-2) + '' + ("0" + dFrom).slice (-2);
          var strTo = ("0" + mTo).slice (-2) + '' + ("0" + dTo).slice (-2);
          if (strFrom > strTo){
            whereRaw += "AND DATE_FORMAT(date, '%m%d') > " + strFrom + " OR DATE_FORMAT(date, '%m%d') < " + strTo + ' ';
          } else {
            whereRaw += "AND DATE_FORMAT(date, '%m%d') BETWEEN " + strFrom + " AND " + strTo + ' ';
          }
        }
        if (self.query.yearsFrom != null && self.query.yearsTo != null){
          whereRaw += "AND YEAR(date) BETWEEN " + self.query.yearsFrom + " AND " +  self.query.yearsTo;
        }
        if (whereRaw.length > 0){
          url += "&whereRaw=" + encodeURI(whereRaw);
        }
        // add order only of not already present
        if (url.indexOf('&order') === -1){
          url += self.constructOrder();
        }
        return url;
      }

      // adds order to url
      self.constructOrder = function(){
        var url = "&order=";
        if (self.order.date.asc){
          return url +='date asc';
        } else if (self.order.date.desc){
          return url +='date desc';
        } else if (self.order.ringNumber.asc){
          return url +='ringnumber asc';
        } else if (self.order.ringNumber.desc){
          return url +='ringnumber desc';
        } else if (self.order.species.asc){
          return url +='species asc';
        } else if (self.order.species.desc){
          return url +='species desc';
        } else if (self.order.sex.asc){
          return url +='sex asc';
        } else if (self.order.sex.desc){
          return url +='sex desc';
        } else if (self.order.age.asc){
          return url +='ageid asc';
        } else if (self.order.age.desc){
          return url +='ageid desc';
        } else if (self.order.station.asc){
          return url +='station asc';
        } else if (self.order.station.desc){
          return url +='station desc';
        } else if (self.order.locality.asc){
          return url +='locality asc';
        } else if (self.order.locality.desc){
          return url +='locality desc';
        } else if (self.order.method.asc){
          return url +='methodName asc';
        } else if (self.order.method.desc){
          return url +='methodName desc';
        } else if (self.order.operation.asc){
          return url +='operation asc';
        } else if (self.order.operation.desc){
          return url +='operation desc';
        }
        return "";
      }
      // resets order of columns
      self.resetOrder = function(){
        self.order = {
          date: {
            asc: false,
            desc: false
          },
          ringNumber: {
            asc: false,
            desc: false
          },
          species: {
            asc: false,
            desc: false
          },
          sex: {
            asc: false,
            desc: false
          },
          age: {
            asc: false,
            desc: false
          },
          station: {
            asc: false,
            desc: false
          },
          locality: {
            asc: false,
            desc: false
          },
          method: {
            asc: false,
            desc: false
          },
          operation: {
            asc: false,
            desc: false
          }
        }
      }

      self.changeOrder = function(type){
        var asc = self.order[type].asc;
        self.resetOrder();
        if (asc){
          self.order[type].desc = true;
        } else {
          self.order[type].asc = true;
        }
        self.getHistory();
      }

      self.selectLocation = function(){
        if (self.selectedLocation){
          self.query.municipality = self.selectedLocation.ID_MunicipalityPart;
          self.query.location = self.selectedLocation.Name;
          $scope.$broadcast('angucomplete-alt:changeInput', 'municipalityId', self.selectedLocation.Municipality);
        }
      }

      if (typeof $state.params.q !== 'undefined' && $state.params.q !== null && $state.params.q !== ''){
        var originalAdditionalUrl = self.additionalUrl;
        self.additionalUrl = $state.params.q;
        self.getHistory();
      }

      // load age codebook
      codebookService.fetchCodebook()
        .then(function(data){
          self.age = data.age;
          self.schemes = data.ringingscheme;
          self.primaryidentificationmethod = data.primaryidentificationmethod;
        }, function(data){
          alert("Při načítání dat došlo k chybě");
        });

      // load ringtypes
      ringsService.fetchRingTypes(true, $rootScope.user.rings.scheme)
        .then(function(data){
          self.ringtypes = data;
        }, function(data){
          alert(data);
        });

      self.pageChanged = function(newPageNumber){
        self.doingResolve = true;
        observationService.fetchObservationOverview(newPageNumber,self.numRecordsPerPage,self.constructUrl())
        .then(function(data){
          self.doingResolve = false;
          self.records = data.items;
          self.numRecords = data.rowCount;
        }, function(data){
          self.doingResolve = false;
          alert("Při načítání dat došlo k chybě");
        });
      }

      // when ringtype is changed, set ringing scheme, ringing information and 
      self.changeRingType = function() {
        if (self.query.serie) {
          self.query.ringInformation = 1;
          self.query.ringType = 'A0';
          self.query.scheme = $rootScope.user.rings.scheme;
        }
      };

      // create url string for summary
      self.constructSummaryUrl = function(){
        var url = 'owner='+"'" + $rootScope.user.User + "'";
        if ((self.query.dateFromS != null && self.query.dateFromS != '')
          || (self.query.dateToS != null && self.query.dateToS != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFromS != null && self.query.dateFromS != ''){
            var dateFrom = yyyymmdd(self.query.dateFromS);
          }
          if (self.query.dateToS != null && self.query.dateToS != ''){
            var dateTo = yyyymmdd(self.query.dateToS);
          }
          url += "&from='" + dateFrom + "'&to='" + dateTo + "'";
          //url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
        }

        return url;
      }

      // sum of rings in order
      self.getTotalSummaryItems = function(){
        self.summaryStats = {
          species:null,
          total:null,
          pull:null,
          ad:null,
          retrap:null
        }
        for (var i = 0; i < self.summary.length; i++){
          self.summaryStats.species += 1;
          self.summaryStats.total += self.summary[i].total;
          self.summaryStats.pull += self.summary[i].pull;
          self.summaryStats.ad += self.summary[i].ad;
          self.summaryStats.retrap += self.summary[i].retrap;
        }
      }

      // get class of row
      self.rowClass = function(idOperation){
        switch(idOperation){
          case 1:
            return 'success'
          case 4:
            return 'warning';
          case 6:
            return 'info';
          default:
            return null;
        }
      }

      // can record be edited?
      self.recordLocked = function(record){
        return record.lastChangeDiff > myConfig.editableTimeLimit;
        /*var today = new Date();
        var timeDiff = Math.abs(new Date(record.lastChange).getTime() - today.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays <= myConfig.editableTimeLimit){
          return false;
        } else {
          return true;
        }*/
      }

      // get all data
      self.getAll = function(){
        if (confirm('Vyhledání všech záznamů může být velmi časově náročné. Opravdu chcete pokračovat?')){
          self.resetForm();
          self.doingResolve = true;
          self.noHistory = false;
          observationService.fetchObservationOverview(1,self.numRecordsPerPage,self.constructUrl())
            .then(function(data){
              self.records = data.items;
              self.numRecords = data.rowCount;
              self.doingResolve = false;
            }, function(data){
              self.doingResolve = false;
              alert("Při načítání dat došlo k chybě");
          });
        }        
      }

      // reset all form options
      self.resetForm = function(){
        self.query = {
          dateFrom: null,
          dateTo: null,
          dateFromS: null,
          dateToS: null,
          location: null,
          species: null,
          municipality: null,
          ringInformation: null,
          ringNumber: null,
          scheme: null,
          seasonFrom: null,
          seasonTo: null,
          sex: null,
          age: null,
          ringType: null,
          yearsFrom: null,
          yearsTo: null,
          serie: null,
          serieFrom: null,
          serieTo: null
        }
        // reset autocompleter
        $rootScope.$broadcast('angucomplete-alt:clearInput');
      }

      self.openDatePicker = function(val){
         if (val == 1){
          self.datePicker1Opened = true;
         } else if (val == 2){
          self.datePicker2Opened = true;
         }
      }

      // when autocompleter option for species is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.query.species = null;
            return;
        }
        self.query.species = selectedValue.originalObject; 
      };

      // when autocompleter option for species is selected, update model
      this.updateChartSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.chartspecies = null;
            return;
        }
        self.chartspecies = selectedValue.originalObject; 
      };

      // when autocompleter option for municipality is selected, update model
      this.updateMunicipality = function (selectedValue) {
        if (!selectedValue) {
            self.query.municipality = null;
            return;
            }
            if (selectedValue) {
              self.query.municipality = selectedValue.originalObject.ID;
            }
      };

      self.getChartData = function(){
        // line chart
        self.chartlineData = [[],[]];
        self.chartlineLabels = [];
        // doughnut sex
        self.chartdoughnutData = [];
        self.chartldoughnutLabels = [];
        // doughnut age
        self.chartdoughnut2Data = [];
        self.chartldoughnut2Labels = [];
        self.doingChartsResolve = true;
        var additionalUrl = '';
        if (self.chartspecies !== null){
          additionalUrl="?species="+self.chartspecies.TaxonID;
        }
        observationService.fetchChartData(additionalUrl)
        .then(function(data){
          if (data["yearCnt"].length == 0){
            self.noChartData = true;
          } else{
            self.noChartData = false;
            for (var i = 0; i<data["yearCnt"].length; i++){
              self.chartlineLabels.push(data["yearCnt"][i].rok);
              self.chartlineData[0].push(data["yearCnt"][i].cntRinging);
              self.chartlineData[1].push(data["yearCnt"][i].cntRetrap);
            }
            for (var i = 0; i<data["sexCnt"].length; i++){
              self.chartldoughnutLabels.push(data["sexCnt"][i].sex);
              self.chartdoughnutData.push(data["sexCnt"][i].cnt);
            }
            for (var i = 0; i<data["ageCnt"].length; i++){
              self.chartldoughnut2Labels.push(data["ageCnt"][i].age);
              self.chartdoughnut2Data.push(data["ageCnt"][i].cnt);
            }
          }
          
          self.doingChartsResolve = false;
        });
      }

      // get summary
      self.getSummary = function(){
        self.doingSummaryResolve = true;
        observationService.fetchSummary(self.constructSummaryUrl())
          .then(function(data){
            self.summary = data;
            self.getTotalSummaryItems();
            self.doingSummaryResolve = false;
          }, function(data){
            self.doingSummaryResolve = false;
            alert("Při načítání dat došlo k chybě");
        });
      }
 
      // redirect to form with record details
      self.editRecord = function(idRecord){
        var params = {'id':idRecord,'q':self.constructUrl()};
        $state.go('app.user.observation.detail',params);
      }

      // path to url saved on server
      self.pdfUrl = function(path){
        var url = myConfig.apiUrl.replace('v1/','userdata/rings/reports/'+path);
        return url;
      }

      // header of csv file
      self.getHeader = function(){
        return ['Druh','Celkem','pull','ostatní','retrapy'];
      }

      self.getColumns = function(){
        return ['spec','total','pull','ad','retrap'];
      }

      // export table as csv
      self.exportCsv = function(){
        var output = angular.copy(self.summary);
        var total = {
          spec: self.summaryStats.species + ' druhů',
          total: self.summaryStats.total,
          pull: self.summaryStats.pull,
          ad: self.summaryStats.ad,
          retrap: self.summaryStats.retrap,
        }
        output.push(total)
        return output;
      }

      // header of csv file
      self.getHeaderRecords = function(){
        return ['Datum','Číslo kroužku','Délka sítí','Stanice','Druh','Druh(lat)'
        ,'Info','Typ značky','Lokalita','X','Y','Obec','Okres','Region'
        ,'Poznámka lok.','Poznámka','Věk','Pohlaví',"Návnada","Metoda odchytu","Manipulace","Status"
        ,'Kondice','Okolnosti','Délka křídla','Třetí ruční letka','Stav vrcholu křídla','Hmotnost','Čas vážení'
        ,'Pelichání','Šat','Zadní dráp','Délka zobáku','Metoda měření zobáku','Délka hlavy','Tarsus','Metoda měření tarsu'
        ,'Délka ocase','Rozdíl délky RP','Délka křídla po 1.LL','Délka prodloužení ocasních per','Délka zářezu na 9.RL','Tuk','Prsní svaly',"Věk pull.","Přesnost věku pull.",'Hnízdní nažina','Holina','Odběr krve','Odběr peří','Staré LK'
        ,'Zápěstní krovka','Pelichání RL','Pelichání LL','Alula',"Typ př. značky","Info př. značky","Barva př. značky"
        ,"Stanice př. značky","Číslo př. značky","CES","Projekt CES","Kontrola CES","Č. sítě CES"
        ,"Délka sítě CES","Pelichání CES","Habitat CES","Čas vážení CES"
        ,"RAS","Projekt RAS","Kontrola RAS","Trvání RAS"
        ,"ID Rodiny","Role","Mláďat v hnízdě","Č.budky/hnízda","Kippův index","Mlynařík hlava","Foto"];
      }

      self.getColumnsRecords = function(){
        return ['dateExport','ringnumber','netLength','station','species','speciesLat'
        ,'operation','methodName','locality','Longitude','Latitude','municipality','county','place'
        ,'siteNote','note','age','sex',"catchingLure","catchingMethod","manipulated","status"
        ,'cond','circumstances','wingLength','thirdPrimary','stateOfWingPoint','mass','measurementTime'
        ,'moult','plumageCode','hindClaw','billLength','billMethod','totalHeadLength','tarsus','tarsusMethod'
        ,'tailLength','tailDifference','firstLLLength','rPExtensionLength','secondRLNotchLength','fatScore','pectoralMuscleScore',"pullusAge","pullusAccuracy"
        ,'broodPatch','juvenilePatch','bloodSample','featherSample','oldGreaterCoverts','carpalCoverts'
        ,'primaryMoult','secondaryMoult','alula',"mrkMarkType","mrkIdOperation","mrkColor"
        ,"mrkStation","mrkRingnumber","ces","cesProjNumber","cesCheckNumber","cesNetNumber"
        ,"cesNetLength","cesCesMoult","cesCesHabitat","cesWeightingTime"
        ,"ras","rasProjNumber","rasCheckNumber","rasCheckDuration"
        ,"ringFamilyId","familyRole","numBirds","nestNumber","kipp","aegithalosMask","photoPath"];
      }


      // export table as csv
      self.exportCsvRecords = function(){
        //return self.records;   
        var deferred = $q.defer();
        self.doingResolve = true;
        console.log(self.constructUrl());
        observationService.fetchFullObservationOverview(self.constructUrl())
          .then(function(data){
            deferred.resolve(data);    
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
          });
        return deferred.promise;
      }
    }
  }
}])
/*user detail modal window*/
.directive('userRetrapModalWindow',['$rootScope','observationService','leafletData'
  ,function($rootScope,observationService,leafletData){
  return {
    restrict : 'E',
    templateUrl : 'templates/user-retrap-modal.tpl.html',
    scope : {
      record: "=",
      instance: "="
    },
    controllerAs : 'UserRetrapModalWindowCtrl',
    bindToController: true,
    controller : function ($scope){

      var self = this;

      self.changeBaseLayer = function (key) {
        leafletData.getMap().then(function (map) {
            leafletData.getLayers().then(function (layers) {
                _.each(layers.baselayers, function (layer) {
                    map.removeLayer(layer);
                });
                map.addLayer(layers.baselayers[key]);
            });
        });
      };

      //console.log(self.record);

      // init center
      self.center = {};
      // init layers
      self.layers = {
        baselayers: {
          leaflet: {
              name: 'OpenStreetMap',
              url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
              type: 'xyz',
              layerOptions: {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }                
          },
          mapycz_Aerial: {
              name: 'Letecká',
              //url: 'https://mapserver.mapy.cz/bing/{z}-{x}-{y}',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
              type: 'xyz',
              layerOptions: {
                //attribution: '<img src="http://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
                attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
              }
          }  
          /*mapycz_Aerial: {
            name: 'Letecká',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            type: 'xyz',
            layerOptions: {
              attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
            }
          },
          mapycz_Base: {
            name: 'Základní',
            url: 'https://mapserver.mapy.cz/base-m/{z}-{x}-{y}',
            type: 'xyz',
            layerOptions: {
              attribution: '<img src="https://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
            }
          },
          mapycz_Turist: {
            name: 'Turistická',
            url: 'https://mapserver.mapy.cz/wturist-m/{z}-{x}-{y}',
            type: 'xyz',
            layerOptions: {
              attribution: '<img src="https://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
            }
          }*/
        }
      };
      // init markers
      self.markers = new Array();
      // paths
      self.paths = {};
      if (self.record.ringingId) {
        observationService.getRetrapCoordinates(self.record.ringingId)  
          .then(function(data){
            // markers
            angular.forEach(data, function(r) {
              self.markers.push({
                lat: r.Latitude,
                lng: r.Longitude,
                draggable: false,
                focus: true,
                message: "Zpětné hlásení"
              });
            }) 
            console.log(self.record);
            self.markers.push({
              lat: Number(self.record.lat2.replace(',','.')),
              lng: Number(self.record.lon2.replace(',','.')),
              draggable: false,
              focus: true,
              message: "Kroužkování"
            });
            // center
            self.center = {
                lat: (Number(self.record.lat1.replace(',','.')) + Number(self.record.lat2.replace(',','.')))/2,
                lng: (Number(self.record.lon1.replace(',','.')) + Number(self.record.lon2.replace(',','.')))/2,
                zoom: 12
            };
            // paths
            self.paths = {
              p1: {
                weight: 4,
                latlngs: [
                  //{ lat: self.record.lat1, lng: self.record.lon1 },
                  //{ lat: self.record.lat2, lng: self.record.lon2 }
                ]
              }
            }
            console.log(self.markers);
            for (var i = 0; i < self.markers.length; i++) {
              self.paths.p1.latlngs.push({ lat: self.markers[i].lat, lng: self.markers[i].lng })
            }
            if (self.record.dist && Number(self.record.dist.replace(',','.')) > 5) {
              self.changeBaseLayer('mapycz_Base');
            }
            leafletData.getMap().then(function(map) {
              map.fitBounds(self.markers);
            });
          }, function(err){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
          });
      } else {
        self.markers.push({
          lat: Number(self.record.lat1.replace(',','.')),
          lng: (self.record.lon1.replace(',','.')),
          draggable: false,
          focus: true,
          message: "Zpětné hlásení"
        });
        self.center = {
            lat: Number(self.record.lat1.replace(',','.')),
            lng: Number(self.record.lon1.replace(',','.')),
            zoom: 12
        };
        leafletData.getMap().then(function(map) {
          map.fitBounds(self.markers);
        });
      }

      // close
      self.cancel = function(){
        self.instance.dismiss();
      }

    }

  }
}]);
